const TABS = [
  { id: "daily", l: "Daily sheet" },
  { id: "sett", l: "NEW SETT" },
];

export const SheetTabs = ({ sheet, onChange, showSett }) => (
  <div className="flex border-b-2 border-slate-900" data-testid="sheet-tabs">
    {TABS.filter((t) => showSett || t.id !== "sett").map((t) => (
      <button key={t.id} data-testid={`sheet-tab-${t.id}`} onClick={() => sheet !== t.id && onChange(t.id)}
        className={`h-10 px-4 text-xs font-bold uppercase tracking-[0.12em] transition-colors ${sheet === t.id
          ? t.id === "sett" ? "bg-amber-400 text-slate-900" : "bg-slate-900 text-white"
          : "bg-white/70 text-slate-500 hover:text-slate-900"}`}>
        {t.l}
      </button>
    ))}
  </div>
);
